import Tick from '@images/proviotics/tick.svg';
import Dash from '@images/proviotics/dash.svg';
import { COMPARISON_TABLE_DAYE_LOGO } from '@constants';

export interface TableData {
  header: string[];
  body: {
    [key: string]: string[];
  };
  hasBottomRow: boolean;
}

export const ProvioticsTableData: TableData = {
  header: ['Comparison', COMPARISON_TABLE_DAYE_LOGO, 'canesflor <br/>vaginal', 'Garden <br/>of life'],
  body: {
    firstRow: ['Clinically tested in humans', Tick, Dash, Dash],
    secondRow: ['Vegan', Tick, Tick, Dash],
    thirdRow: ['Live cell cultures per capsule', '2.5bn', '0.1bn', '1.66bn'],
    fourthRow: ['Take orally for gut health', Tick, Tick, Tick],
    fifthRow: ['Take vaginally for vaginal health', Tick, Dash, Dash]
  },
  hasBottomRow: true
};

export const VMSTableData: TableData = {
  header: ['Comparison', COMPARISON_TABLE_DAYE_LOGO, 'canestest', "Let's get checked", 'The STI clinic'],
  body: {
    firstRow: ['Non-invasive tampon samples', Tick, Dash, Dash, Dash],
    secondRow: ['Easy at-home screening', Tick, Tick, Tick, Tick],
    thirdRow: ['Detect BV & thrush pathogens', Tick, Tick, Dash, Tick],
    fourthRow: ['Microbiome composition', Tick, Dash, Dash, Dash],
    fifthRow: ['Pharmacy prescriptions', Tick, Dash, Dash, Dash],
    sixthRow: ['Online GP consultations', Tick, Dash, Dash, Dash],
    seventhRow: ['NHS appointments', Tick, Dash, Dash, Dash],
    eighthRow: ['Flexible subscription', Tick, Dash, Dash, Dash]
  },
  hasBottomRow: false
};
